import { useSyncExternalStore } from 'react';
import { shellBridgeStore } from './storeSingleton';
import type { AggregatedShellUiConfig } from './ShellBridgeStore';

/** Full aggregate of all app UI configs — triggers re-render on any change */
export function useShellContributions(): AggregatedShellUiConfig {
  return useSyncExternalStore(shellBridgeStore.subscribe, shellBridgeStore.getSnapshot);
}
